var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegramIconPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.470095 5.58989C1.8701 4.81989 3.44009 4.16989 4.90009 3.51989C7.42009 2.45989 9.9401 1.40989 12.5001 0.439886C13.0001 0.269886 13.8901 0.109886 13.9801 0.849886C13.9301 1.88989 13.7401 2.92989 13.6001 3.95989C13.2601 6.23989 12.8601 8.50988 12.4701 10.7799C12.3401 11.5399 11.3901 11.9299 10.7801 11.4399C9.3201 10.4599 7.86009 9.47989 6.42009 8.47989C5.95009 7.99989 6.3901 7.30989 6.8101 6.96988C8.0101 5.78989 9.2801 4.77989 10.4201 3.53989C10.7301 2.79989 9.8201 3.41989 9.52009 3.60989C7.8801 4.73989 6.2801 5.93988 4.5401 6.93988C3.6601 7.42988 2.6201 7.00988 1.7401 6.73988C0.950095 6.41988 -0.209905 6.08989 0.470095 5.58989Z",
    fill: "#7043FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIconPurple);
export default __webpack_public_path__ + "static/media/telegram_icon_purple.59030e1f204c6893f701f779d2cb685c.svg";
export { ForwardRef as ReactComponent };